import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    position: relative;
    
    /* Garante que o conteúdo não ultrapasse os limites */
    overflow: hidden auto !important;
    
    /* Force all content to stay within bounds */
    * {
        max-width: 100%;
        box-sizing: border-box;
    }

    /* Menu component - allow vertical scroll */
    .ant-menu {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
        overflow-y: visible !important;
        box-sizing: border-box !important;
        height: auto !important;
    }

    .ant-menu.ant-menu-inline {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
        overflow-y: visible !important;
    }
    
    /* Modern sidebar styling */
    .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {
        background-color: var(--sidebar-option-selected) !important;
        border-radius: 8px;
        margin: 4px 8px;
        width: calc(100% - 16px);
        max-width: calc(100% - 16px) !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    .ant-menu-dark .ant-menu-item-selected {
        border-right: 0;
    }

    .ant-menu-dark .ant-menu-item-selected::after {
        display: none;
    }

    /* Menu items styling - Reduced padding */
    .ant-menu-dark .ant-menu-item,
    .ant-menu-dark .ant-menu-submenu-title {
        margin: 4px 8px;
        padding: 10px 12px !important;
        border-radius: 8px;
        height: auto;
        min-height: 40px;
        line-height: 1.5;
        display: flex;
        align-items: center;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-size: 14px;
        font-weight: 500;
        overflow: hidden !important;
        max-width: calc(100% - 16px) !important;
        width: calc(100% - 16px) !important;
        box-sizing: border-box !important;
    }

    .ant-menu-dark .ant-menu-item:hover,
    .ant-menu-dark .ant-menu-submenu-title:hover {
        background-color: rgba(255, 255, 255, 0.1) !important;
        overflow: hidden !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
    }

    .ant-menu-dark .ant-menu-item:active,
    .ant-menu-dark .ant-menu-submenu-title:active {
        background-color: rgba(255, 255, 255, 0.15) !important;
    }

    /* Icon alignment and spacing - Reduced size */
    .ant-menu-dark .ant-menu-item-icon {
        font-size: 16px !important;
        width: 16px !important;
        min-width: 16px !important;
        max-width: 16px !important;
        height: 16px !important;
        min-height: 16px !important;
        max-height: 16px !important;
        margin-right: 10px !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        vertical-align: middle;
        transition: all 0.3s ease;
        line-height: 1;
        flex-shrink: 0;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    /* SVG icon size control - Reduced to 16px */
    .ant-menu-dark .ant-menu-item-icon .svg-icon,
    .ant-menu-dark .ant-menu-item-icon svg,
    .ant-menu-dark .ant-menu-item-icon > *,
    .ant-menu-dark .ant-menu-item-icon * {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        min-width: 16px !important;
        min-height: 16px !important;
        font-size: 16px !important;
        flex-shrink: 0 !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    /* Ensure all SVG elements inside icons are controlled */
    .ant-menu-dark .ant-menu-item-icon .svg-icon svg,
    .ant-menu-dark .ant-menu-item-icon svg svg,
    .ant-menu-dark .ant-menu-item-icon svg path,
    .ant-menu-dark .ant-menu-item-icon svg circle,
    .ant-menu-dark .ant-menu-item-icon svg rect,
    .ant-menu-dark .ant-menu-item-icon svg polygon {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
    }

    /* Submenu icon size control - Reduced */
    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon {
        font-size: 16px !important;
        width: 16px !important;
        min-width: 16px !important;
        max-width: 16px !important;
        height: 16px !important;
        min-height: 16px !important;
        max-height: 16px !important;
        margin-right: 10px !important;
    }

    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon .svg-icon,
    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon svg,
    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon > *,
    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon * {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        min-width: 16px !important;
        min-height: 16px !important;
        font-size: 16px !important;
        box-sizing: border-box !important;
    }

    /* Additional control for react-icons */
    .ant-menu-dark .ant-menu-item-icon .svg-icon[class*="react-icons"],
    .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon .svg-icon[class*="react-icons"] {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        min-width: 16px !important;
        min-height: 16px !important;
    }

    .ant-menu-dark .ant-menu-submenu-title .ant-menu-submenu-arrow {
        font-size: 12px;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.3s ease;
    }

    .ant-menu-dark .ant-menu-submenu-title {
        display: flex;
        align-items: center;
        position: relative;
    }

    .ant-menu-dark .ant-menu-item {
        display: flex;
        align-items: center;
    }

    .ant-menu-dark .ant-menu-item > a {
        display: flex;
        align-items: center;
        width: 100%;
        max-width: 100% !important;
        line-height: 1.5;
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
        box-sizing: border-box !important;
    }

    /* Ensure hover doesn't break boundaries */
    .ant-menu-dark .ant-menu-item:hover > a,
    .ant-menu-dark .ant-menu-submenu-title:hover {
        max-width: 100% !important;
        overflow: hidden !important;
        box-sizing: border-box !important;
    }

    .ant-menu-dark .ant-menu-item:hover .ant-menu-item-icon,
    .ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-item-icon {
        transform: none !important;
        overflow: hidden !important;
    }

    /* Prevent icon overflow on hover */
    .ant-menu-dark .ant-menu-item:hover .ant-menu-item-icon .svg-icon,
    .ant-menu-dark .ant-menu-item:hover .ant-menu-item-icon svg,
    .ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-item-icon .svg-icon,
    .ant-menu-dark .ant-menu-submenu-title:hover .ant-menu-item-icon svg {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        min-width: 16px !important;
        min-height: 16px !important;
    }

    /* Submenu styling */
    .ant-menu-dark .ant-menu-submenu-title {
        border-radius: 8px;
    }

    .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
        background-color: rgba(255, 255, 255, 0.08) !important;
    }

    /* Submenu items */
    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
        background: var(--sidebar-subMenuItems-background) !important;
        border-radius: 8px;
        margin: 8px;
        padding: 4px 0;
    }

    .ant-menu-dark .ant-menu-inline .ant-menu-item {
        margin: 2px 8px;
        padding-left: 48px !important;
        border-radius: 6px;
        height: auto;
        min-height: 40px;
        line-height: 1.5;
        padding-top: 10px !important;
        padding-bottom: 10px !important;
        display: flex;
        align-items: center;
    }

    .ant-menu-dark .ant-menu-inline .ant-menu-item:hover {
        background-color: rgba(255, 255, 255, 0.12) !important;
        padding-left: 52px !important;
    }

    .ant-menu-dark .ant-menu-inline .ant-menu-item-selected {
        background-color: rgba(255, 255, 255, 0.15) !important;
    }

    /* Divider styling */
    .ant-divider-horizontal {
        background-color: rgba(255, 255, 255, 0.15) !important;
        margin: 12px 16px !important;
        border: none;
        height: 1px;
    }

    /* Menu container - allow vertical scroll */
    .ant-menu.ant-menu-dark, 
    .ant-menu-dark .ant-menu-sub, 
    .ant-menu.ant-menu-dark .ant-menu-sub {
        background: var(--sidebar-background);
        border: none;
        overflow-x: hidden !important;
        overflow-y: visible !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
    }

    /* Prevent any menu item from overflowing */
    .ant-menu.ant-menu-dark .ant-menu-item,
    .ant-menu.ant-menu-dark .ant-menu-submenu-title {
        max-width: 100% !important;
        overflow: hidden !important;
    }

    .ant-menu.ant-menu-dark .ant-menu-item:hover,
    .ant-menu.ant-menu-dark .ant-menu-submenu-title:hover {
        max-width: 100% !important;
        overflow: hidden !important;
    }

    /* Smooth transitions */
    .ant-menu-dark .ant-menu-item,
    .ant-menu-dark .ant-menu-submenu-title,
    .ant-menu-dark .ant-menu-item-icon {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    /* Scrollbar styling for modern look */
    &::-webkit-scrollbar,
    .ant-layout-sider-children::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track,
    .ant-layout-sider-children::-webkit-scrollbar-track {
        background: transparent;
    }

    &::-webkit-scrollbar-thumb,
    .ant-layout-sider-children::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover,
    .ant-layout-sider-children::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }

    /* Firefox scrollbar */
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) transparent;

    /* When sidebar is collapsed - ensure icons stay within bounds */
    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-item-icon,
    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon {
        width: 16px !important;
        min-width: 16px !important;
        max-width: 16px !important;
        height: 16px !important;
        min-height: 16px !important;
        max-height: 16px !important;
        margin-right: 0 !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-item-icon .svg-icon,
    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-item-icon svg,
    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon .svg-icon,
    .ant-layout-sider-collapsed .ant-menu-dark .ant-menu-submenu-title .ant-menu-item-icon svg {
        width: 16px !important;
        height: 16px !important;
        max-width: 16px !important;
        max-height: 16px !important;
        min-width: 16px !important;
        min-height: 16px !important;
    }

    /* Force icon container to respect boundaries */
    .ant-menu-dark .ant-menu-item,
    .ant-menu-dark .ant-menu-submenu-title {
        position: relative;
        overflow: hidden !important;
        max-width: calc(100% - 16px) !important;
        width: calc(100% - 16px) !important;
    }

    /* Hover state - ensure no overflow */
    .ant-menu-dark .ant-menu-item:hover,
    .ant-menu-dark .ant-menu-submenu-title:hover {
        max-width: calc(100% - 16px) !important;
        width: calc(100% - 16px) !important;
        overflow: hidden !important;
        transform: none !important;
    }

    .ant-menu-dark .ant-menu-item-icon {
        position: relative;
        z-index: 1;
        overflow: hidden !important;
        clip-path: inset(0);
    }

    /* Additional safety: clip any overflow */
    .ant-menu-dark .ant-menu-item-icon * {
        max-width: 16px !important;
        max-height: 16px !important;
        overflow: hidden !important;
    }

    /* Ensure all children respect boundaries on hover */
    .ant-menu-dark .ant-menu-item:hover *,
    .ant-menu-dark .ant-menu-submenu-title:hover * {
        max-width: 100% !important;
        overflow: hidden !important;
    }
`;